// @ts-nocheck

import { __ } from '../i18n/l10n';

export default (lines, bankers, k) => {
  if (k === lines - bankers) {
    const betsAccLabel = __('%1$s selection', lines, '%1$s selections');

    return __('Accumulator %1$s', betsAccLabel);
  }
  if (bankers > 0) {
    const systemLabel = __('System %1$s/%2$s', [k, lines - bankers]);
    const baseLabel = __('%1$s Base', bankers, '%1$s Bases');

    return __('%1$s + %2$s', [baseLabel, systemLabel]);
  }
  if (k === 1) {
    return __('%1$s single bet', lines - bankers, '%1$s single bets');
  }
  return __('System %1$s/%2$s', [k, lines - bankers]);
};
